export default { sha: '166b0ecb988d1ad1bfbc2e859ee3d9664db59a51', buildNumber: 'undefined' }
